import { stationsMaster } from '../data/stations';

export function mergeTrainsForStations(trains) {
  // stationsMaster をディープクローンする
  const stations = JSON.parse(JSON.stringify(stationsMaster));

  trains.forEach(train => {
    if (train.next_station_id === null) {
      stationsPushTrain(stations, train, train.station_id, 'bant');
    } else if (train.next_station_id !== null) {
      let nextStationId = null;

      if (train.direction === 'up') {
        nextStationId = train.next_station_id + 1;
      } else {
        nextStationId = train.next_station_id;
      }

      stationsPushTrain(stations, train, nextStationId, 'sift')
    }
  });

  return stations;
}

export function trainHtmlClass(train) {
  return specialTrainHtmlClass(train) || defaultTrainHtmlClass(train);
}

function specialTrainHtmlClass(train) {
  if (train.train_orchestration_number === 70) {
    return 'reysol_express'
  }

  return null
}

function defaultTrainHtmlClass(train) {
  // 資料: https://kray.docbase.io/posts/3761269
  if (train.train_orchestration_number >= 1 && train.train_orchestration_number <= 14)
  {
    return 'tx1000'
  }

  if (
      (train.train_orchestration_number >= 67 && train.train_orchestration_number <= 70) ||
      (train.train_orchestration_number >= 72 && train.train_orchestration_number <= 73)
    )
  {
    return 'tx2000-zoubi'
  }

  if (train.train_orchestration_number >= 81 && train.train_orchestration_number <= 85)
  {
    return 'tx3000'
  }

  return 'tx2000'
}

export function displayDelay(delay) {
  if (delay === 0) {
    return delay;
  }

  const delayMinute = Math.floor(delay / 60);
  if (delayMinute >= 100) {
    return 99;
  }

  return delayMinute;
}

export function findTrain(trains, trainNumber) {
  const train = trains.find(train => train.train_number === trainNumber);

  console.log(train);
  return train;
}

export function destinationStationName(train) {
  const station = stationsMaster.find(station => station.stationId === train.destination_station_id);

  if (station != null) {
    return station.name
  }

  return '';
}

export function createTrainSchedule(train, trainDetails) {
  const result = stationsMaster.map(station => {
    if (beforeFinalStation(train, station) && passedStation(train, station)) {
      let stationSchedule = { stationName: station.name, stationId: station.stationId }

      const stopStation = trainDetails.find(trainDetail => trainDetail.name.replace(/[（〔][^）〕]*[）〕]/g, '').trim() == station.name);
      if (stopStation !== undefined) {
        stationSchedule.departureTime = stopStation.departure;
        stationSchedule.arrivalTime = stopStation.arrival;
      }

      return stationSchedule;
    }

    return null;
  }).filter(Boolean)

  if (train.direction === 'up') {
    return result.reverse();
  }

  return result;
}

const beforeFinalStation = (train, station) => {
  if (train.direction === 'up') {
    return train.destination_station_id <= station.stationId;
  }

  return train.destination_station_id >= station.stationId;
}

const passedStation = (train, station) => {
  if (train.direction === 'up') {
    if (train.next_station_id === null) {
      return station.stationId <= train.station_id;
    }

    return station.stationId < train.station_id;
  }

  if (train.next_station_id === null) {
    return station.stationId >= train.station_id;
  }

  return station.stationId > train.station_id;
}

const stationsPushTrain = (stations, train, stationId, kind) => {
  const train_kind = train.train_kind_id === 1 ? 'local' : 'honors';

  return stations.map(station => {
    if (station.stationId == stationId && [1, 2, 3, 4, 5, 13, 14, 15].includes(train.train_kind_id)) {
      station.trains[train.direction][kind][train_kind].push(train);

      if (kind === 'sift') {
        station.trains[train.direction][kind][train_kind].sort((a, b) => a.position - b.position);
      } else {
        // 普通列車x2、若しくは優等列車x2が同じ駅の同じ方向にいる場合
        if (station.trains[train.direction][kind][train_kind].length > 1) {
          const train1 = station.trains[train.direction][kind][train_kind][0];
          const train2 = station.trains[train.direction][kind][train_kind][1];
          station.trains[train.direction][kind][train_kind] = [];

          // 上り: positionが小さい方が外側レーン
          // 下り: positionが大きい方が外側レーン
          // となるように列車を配置する
          const isFirstIsHonor = firstIsHonor(train, train1, train2);
          const honorsTrain = isFirstIsHonor ? train1 : train2;
          const localTrain  = isFirstIsHonor ? train2 : train1;

          station.trains[train.direction][kind]['honors'].push(honorsTrain);
          station.trains[train.direction][kind]['local'].push(localTrain);
        }
      }
    }

    return station;
  });
};

const firstIsHonor = (train, train1, train2) => {
  const upDirection = train.direction === 'up';
  if (upDirection) {
    return train1.position > train2.position;
  }

  return train1.position < train2.position;
}
